import { render, staticRenderFns } from "./BaseFullscreenDialog.vue?vue&type=template&id=004cd3a5"
import script from "./BaseFullscreenDialog.vue?vue&type=script&lang=ts"
export * from "./BaseFullscreenDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports